import { React, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MainLogo from "../../assets/images/mainlogoNew.png";
import { Box, Drawer, IconButton, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CustomButton from "../button/CustomButton";
import { ReactComponent as HamburgerIcon } from "../../assets/svg/hamburger-menu-icon.svg";
import { ReactComponent as UserIcon } from "../../assets/svg/user-icon-white.svg";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setOpenAgentLoginFlow, setOpenLoginFlow, setOpenAgentSignupFlow, setAgentSignupStepCount } from "../../redux/login";
import { setLanguage, selectLanguage, selectLangParam } from "../../redux/language";
import { useLocation } from "react-router-dom";
import { GetAllPropertyTyoes } from "../../services/PostProperty";
import { GetHomePropertyCategoryByType } from "../../services/homepage";

const Header = ({ authUser }) => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const language = useSelector(selectLanguage);
  const langParam = useSelector(selectLangParam);
  const [openMenuDrawer, setOpenMenuDrawer] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [name, setName] = useState("Sign In");
  const [agentName, setAgentName] = useState("");
  const isAgentLoggedIn = Boolean(localStorage.getItem("agent_token"));

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 70);
    });
  }, []);

  // Sync i18n on mount with saved language
  useEffect(() => {
    i18n.changeLanguage(language);

    const userInfo = JSON.parse(localStorage.getItem("user"));
    if (userInfo) {
      getInitialsName(userInfo);
    }

    const agentInfo = JSON.parse(localStorage.getItem("agent_user"));
    if (agentInfo) {
      const aname = `${agentInfo.first_name || ""} ${agentInfo.last_name || ""}`;
      const fullName = aname
        .split(" ")
        .map((word) => word[0]?.toUpperCase())
        .join("");
      setAgentName(fullName);
    }
  }, []);

  // Re-fetch backend-translated data whenever langParam changes
  useEffect(() => {
    if (langParam) {
      dispatch(GetAllPropertyTyoes(langParam));
      dispatch(GetHomePropertyCategoryByType(langParam));
    }
  }, [langParam, dispatch]);

  const onLanguageChange = (lang) => {
    dispatch(setLanguage(lang));
    i18n.changeLanguage(lang);
  };
  const userLoggedIn = Boolean(localStorage.getItem("token"));
  const location = useLocation();
  const currentPath = location.pathname;

  const getInitialsName = (userInfo) => {
    const sname = `${userInfo.first_name ? userInfo.first_name : ""} ${
      userInfo.middle_name ? userInfo.middle_name : ""
    } ${userInfo.last_name ? userInfo.last_name : ""}`;
    const finalName = sname
      .split(" ")
      .map((word) => word[0]?.toUpperCase())
      .join("");
    setName(finalName);
  };

  const handleAgentDashboard = () => {
    const userToken = localStorage?.getItem("agent_token");
    if (
      userToken &&
      userToken?.length > 0 &&
      userToken !== null &&
      userToken !== undefined &&
      userToken !== "null" &&
      userToken !== "undefined"
    ) {
      navigate("/agent-dashboard");
    } else {
      // Open agent registration/signup (new flow)
      dispatch(setAgentSignupStepCount(1));
      dispatch(setOpenAgentSignupFlow(true));
    }
  };
  return (
    <>
      <Drawer
        anchor="left"
        className="mobile-nav-side-drawer"
        open={openMenuDrawer}
        onClose={() => setOpenMenuDrawer(false)}
      >
        <Box
          className="mobile-nav-container"
          sx={{ display: "flex", flexDirection: "column", gap: "3rem" }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link to="/">
              <img src={MainLogo} alt="i-moz-logo" className="logo-img" />
            </Link>
            <FormControl
              variant="standard"
              sx={{ ml: 4, minWidth: 120, color: "black" }}
              size="small"
              className="language"
            >
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={language}
                onChange={(event) => onLanguageChange(event.target.value)}
                sx={{ color: "black" }}
                renderValue={(value) => {
                  // Display format: PT|EN with active language highlighted
                  return (
                    <span
                      style={{
                        display: "flex",
                        gap: "4px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: value === "pr" ? "bold" : "normal",
                          color: value === "pr" ? "black" : "#999",
                        }}
                      >
                        PT
                      </span>
                      <span style={{ color: "#999" }}>|</span>
                      <span
                        style={{
                          fontWeight: value === "en" ? "bold" : "normal",
                          color: value === "en" ? "black" : "#999",
                        }}
                      >
                        EN
                      </span>
                    </span>
                  );
                }}
              >
                <MenuItem value="en">{t("English")}</MenuItem>
                <MenuItem value="pr">{t("Portuguese")}</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Link className="mobile-nav-links" to="/">
              <Typography
                variant="sSize"
                component="div"
                className={`font-w-500 mozHeaderNavTypo text-center ${
                  currentPath === "/" ? "mozNavSelected" : ""
                }`}
              >
                {t("home")}
              </Typography>
            </Link>

            <Link className="mobile-nav-links" to="/home-properties">
              <Typography
                variant="sSize"
                component="div"
                className={`font-w-500 mozHeaderNavTypo text-center ${
                  currentPath === "/home-properties" ? "mozNavSelected" : ""
                }`}
              >
                {t("Properties")}
              </Typography>
            </Link>
            <Link className="mobile-nav-links" to="/services">
              <Typography
                variant="sSize"
                component="div"
                className={`font-w-500 mozHeaderNavTypo text-center ${
                  currentPath === "/services" ? "mozNavSelected" : ""
                }`}
              >
                {t("services")}
              </Typography>
            </Link>
            <Link className="mobile-nav-links" to="/about">
              <Typography
                variant="sSize"
                component="div"
                className={`font-w-500 mozHeaderNavTypo text-center ${
                  currentPath === "/about" ? "mozNavSelected" : ""
                }`}
              >
                {t("about")}
              </Typography>
            </Link>
            <Link className="mobile-nav-links" to="/contact">
              <Typography
                variant="sSize"
                component="div"
                className={`font-w-500 mozHeaderNavTypo text-center ${
                  currentPath === "/contact" ? "mozNavSelected" : ""
                }`}
              >
                {t("contact")}
              </Typography>
            </Link>

            {/* {!isAgentLoggedIn && !userLoggedIn && (
              <Typography
                variant="xxsSize"
                className="font-w-500 mozHeaderNavTypo"
                sx={{ cursor: "pointer" }}
                onClick={handleAgentDashboard}
              >
                {t("Homepage.BecomeRealEstateAgent")}
              </Typography>
            )} */}
            {isAgentLoggedIn === true && (
              <CustomButton
                buttonVariant="primary"
                borderRadius="primary"
                isSelected={true}
                buttonText={agentName}
                typoVariant="xxsSize"
                extraButtonStyle={{ padding: "10px 20px" }}
                typoClass="font-w-500 text-white"
                colorVariant="primary"
                leadingIcon={true}
                iconStyling={{
                  width: "24px",
                  height: "24px",
                  marginRight: "5px",
                }}
                IconSvg={UserIcon}
                onClick={() => navigate("/agent-dashboard")}
              />
            )}
          </Box>
          {!userLoggedIn && !isAgentLoggedIn && (
            <>
              <CustomButton
                buttonVariant="secondary"
                borderRadius="secondary"
                buttonText={t("Homepage.BecomeAnAgent")}
                typoVariant="xsSize"
                extraButtonStyle={{ padding: "10px 16px" }}
                typoClass="font-w-500"
                colorVariant="primary"
                onClick={handleAgentDashboard}
              />
              <CustomButton
                buttonVariant="primary"
                borderRadius="primary"
                isSelected={true}
                buttonText="Log In"
                typoVariant="xsSize"
                extraButtonStyle={{ padding: "10px 20px" }}
                typoClass="font-w-500 text-white"
                onClick={() => dispatch(setOpenLoginFlow(true))}
                colorVariant="primary"
              />
            </>
          )}
          {userLoggedIn === true && (
            <CustomButton
              buttonVariant="primary"
              borderRadius="primary"
              isSelected={true}
              buttonText={name}
              onClick={() => navigate("/my-property")}
              IconSvg={UserIcon}
              typoVariant="xsSize"
              extraButtonStyle={{ padding: "10px 20px" }}
              typoClass="font-w-500 text-white"
              colorVariant="primary"
            />
          )}
        </Box>
      </Drawer>
      <header className={scroll ? "header-offset" : ""}>
        <nav className={`header-nav ${scroll ? "sticky-header" : ""}`}>
          <Box className="mozContainer">
            <Box className="header-nav-container">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Link to="/">
                  <img src={MainLogo} alt="i-moz-logo" className="logo-img" />
                </Link>
              </Box>

              <Box className="header-nav-link-group">
                <Link to="/">
                  <Typography
                    variant="xxsSize"
                    // className="font-w-500 mozHeaderNavTypo mozNavSelected"
                    className={`font-w-500 mozHeaderNavTypo ${
                      currentPath === "/" ? "mozNavSelected" : ""
                    }`}
                  >
                    {t("home")}
                  </Typography>
                </Link>
                <Link to="/home-properties">
                  <Typography
                    variant="xxsSize"
                    // component="div"
                    className={`font-w-500 mozHeaderNavTypo  ${
                      currentPath === "/home-properties" ? "mozNavSelected" : ""
                    }`}
                  >
                    {t("Properties")}
                  </Typography>
                </Link>
                <Link to="/services">
                  <Typography
                    variant="xxsSize"
                    // className="font-w-500 mozHeaderNavTypo"
                    className={`font-w-500 mozHeaderNavTypo ${
                      currentPath === "/services" ? "mozNavSelected" : ""
                    }`}
                  >
                    {t("services")}
                  </Typography>
                </Link>
                <Link to="/about">
                  <Typography
                    variant="xxsSize"
                    // className="font-w-500 mozHeaderNavTypo"
                    className={`font-w-500 mozHeaderNavTypo ${
                      currentPath === "/about" ? "mozNavSelected" : ""
                    }`}
                  >
                    {t("about")}
                  </Typography>
                </Link>
                <Link to="/contact">
                  <Typography
                    variant="xxsSize"
                    // className="font-w-500 mozHeaderNavTypo"
                    className={`font-w-500 mozHeaderNavTypo ${
                      currentPath === "/contact" ? "mozNavSelected" : ""
                    }`}
                  >
                    {t("contact")}
                  </Typography>
                </Link>

                {/* {!isAgentLoggedIn && !userLoggedIn && (
                  <Typography
                    variant="xxsSize"
                    className="font-w-500 mozHeaderNavTypo"
                    sx={{ cursor: "pointer" }}
                    onClick={handleAgentDashboard}
                  >
                    {t("Homepage.BecomeRealEstateAgent")}
                  </Typography>
                )} */}
                {isAgentLoggedIn === true && (
                  <CustomButton
                    buttonVariant="primary"
                    borderRadius="primary"
                    isSelected={true}
                    buttonText={agentName}
                    typoVariant="xxsSize"
                    extraButtonStyle={{ padding: "8px 20px" }}
                    typoClass="font-w-500 text-white"
                    colorVariant="primary"
                    leadingIcon={true}
                    iconStyling={{
                      width: "24px",
                      height: "24px",
                      marginRight: "5px",
                    }}
                    IconSvg={UserIcon}
                    onClick={() => navigate("/agent-dashboard")}
                  />
                )}
                {!userLoggedIn && !isAgentLoggedIn && (
                  <>
                    <CustomButton
                      // buttonVariant="secondary"
                      // borderRadius="secondary"
                      buttonText={t("Homepage.BecomeAnAgent")}
                      typoVariant="xxsSize"
                      extraButtonStyle={{
                        // padding: "8px 16px",
                        // border: "1.5px solid #0085fd",
                        // borderRadius: "8px",
                        color: "#0085fd",
                        backgroundColor: "transparent",
                        "&:hover": { backgroundColor: "#e8f3ff" },
                      }}
                      typoClass="font-w-500"
                      onClick={handleAgentDashboard}
                    />
                    <CustomButton
                      // buttonVariant="primary"
                      // borderRadius="primary"
                      isSelected={true}
                      buttonText={t("LogIn.logIn")}
                      typoVariant="xxsSize"
                      extraButtonStyle={{ padding: "8px 20px" }}
                      typoClass="font-w-500 text-white"
                      colorVariant="primary"
                      onClick={() => dispatch(setOpenLoginFlow(true))}
                    />
                  </>
                )}
                {userLoggedIn === true && (
                  <CustomButton
                    buttonVariant="primary"
                    borderRadius="primary"
                    isSelected={true}
                    buttonText={name}
                    typoVariant="xxsSize"
                    extraButtonStyle={{ padding: "8px 20px" }}
                    typoClass="font-w-500 text-white"
                    colorVariant="primary"
                    leadingIcon={true}
                    iconStyling={{
                      width: "24px",
                      height: "24px",
                      marginRight: "5px",
                    }}
                    IconSvg={UserIcon}
                    onClick={() => navigate("/my-property")}
                  />
                )}
                <FormControl
                  variant="standard"
                  sx={{
                    ml: 1,
                    minWidth: 60,
                    color: "white",
                    "@media only screen and (min-width: 280px) and (max-width: 1023px)":
                      {
                        display: "none",
                      },
                  }}
                  size="small"
                  className="language"
                >
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={language}
                    displayEmpty
                    onChange={(event) => onLanguageChange(event.target.value)}
                  >
                    <MenuItem value="en">{t("English")}</MenuItem>
                    <MenuItem value="pr">{t("Portuguese")} </MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box className="header-nav-mobile-group">
                <IconButton
                  type="button"
                  sx={{ p: "5px" }}
                  aria-label="hamburger-icon"
                  onClick={() => setOpenMenuDrawer(true)}
                >
                  <HamburgerIcon className="header-nav-hamburger-icon" />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </nav>
      </header>
    </>
  );
};

export default Header;
